import { render } from "./StatisticPanel.vue?vue&type=template&id=efbe3cf8&scoped=true"
import script from "./StatisticPanel.vue?vue&type=script&lang=js"
export * from "./StatisticPanel.vue?vue&type=script&lang=js"

import "./StatisticPanel.vue?vue&type=style&index=0&id=efbe3cf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efbe3cf8"]])

export default __exports__